module.exports = __webpack_public_path__ + "img/icon-eraser.a6d8b39b.png";